import React, { FunctionComponent, useState, useEffect, useRef } from 'react';
import { Button, Icon, TextArea, Loader, Modal } from '@scuf/common';
import axios from '../../../../utils/APIUtils';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store';
import moment from 'moment';
import { getCommentSelector, getCommentsDetail, } from '../../../../slices/allOpportunitySlice';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from '../../../Snackbar/Snackbar';
import { getUserInfo } from '../../../../slices/userProfileSlice';
import { FileUpload } from '../../../../components/UploadFileModal/FileUpload';
import { updateComments } from '../../../../services/UserAction';
import { ICommentModal } from '../../../../models/IOpportunitiesAPIModel';
import addNotesIcon from '../../../../images/add-notes.png';
import { EMPTY_NOTES_TEXT, COMMENT_TYPE, ERROR_MSG_FOR_USER_RESPONSE, COMMENT_ACTION, COMMENT_NOTE, OPPORTUNITIES_API_PATHS, HAS_SCRIPT, COMMENT_UPLOAD_TYPE, IMAGE_NOT_FOUND, } from '../../../../constants/constants';
import './AuditTrailActivity.scss';
import { tagEvent, TAG_EVENT_CONST } from 'src/utils/analytics/analytics.service.util';
import Notes from "../../NewCardDesign/Notes/Notes";
import NotesFooter from "../../NewCardDesign/Notes/NotesFooter";

import { getMessage } from 'src/message/utils';
interface INotesProps {
  onClose: Function;
  opportunityId: any;
  opportunityStatus: string;
  open?: boolean;
  opportunityObjectName: any;
  role_name?: string;
}
const AuditTrailActivity: FunctionComponent<INotesProps> = (props) => {
  type ToastType = 'loading' | 'failure' | 'success';
  const { status: commentsStatus, data: commentsData } =
    useSelector(getCommentSelector);
  const [newNote, setNewNote] = useState('');
  const [btnText, setBtnText] = useState('Add Comment');
  const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
  const [commentList, setCommentList] = useState([] as any);
  const [opportunityDetailLoading] = useState(true);
  const dispatch = useAppDispatch();
  const [enableRetryErr, setEnableRetryErr] = useState(false);
  const { email } = useSelector(getUserInfo);
  const [hasScript, setHasScript] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [addedcomment, setAddedcomment] = useState(false);
  const [expantActivity, setExpantActivity] = useState("View More");
  const [defaultActivityCount, setDefaultActivityCount] = useState(3);
  const addCommentText = getMessage('app.anomalydetails.auditTrail.addcomment');

  const modalRef = useRef();

  useEffect(() => {
    dispatch(getCommentsDetail(props.opportunityId));
    if (modalRef.current) {
      console.log(modalRef.current);
    }
  }, []);
  const handleViewMore = () => {
    if (expantActivity === "View More") {
      setExpantActivity("View Less");
      if (commentsData) {
        setDefaultActivityCount(commentsData.activity.length);
      }
    } else if (expantActivity === "View Less") {
      setExpantActivity("View More")
      setDefaultActivityCount(3);
    }
  }
  const downloadFileStatusToast = (type: ToastType) => {
    if (type === 'loading') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-info"
            root="common"
            size="large"
            color="#007ad9"
            className="status-indicator-icon"
          />{' '}
          Downloading file. It may take few minutes to complete.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'success') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-check"
            root="common"
            size="large"
            color="#279d2b"
            className="status-indicator-icon"
          />
          File downloaded successfully.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'failure') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          <p>File download operation failed.</p>
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };
  const addComment = (userInput: any) => {
    let comment = [...commentList];
    comment = [...comment, userInput];
    setCommentList(comment);
  };

  const addNewNote = () => {
    let inValidCharacter = /[<>()&#]/;
    setAddedcomment(true);
    if (!inValidCharacter.test(newNote)) {
      const data: ICommentModal = {
        user_comment: newNote,
        type: 'comment',
      };
      setEnableRetryErr(false);
      setacceptActionInProgress(true);
      setBtnText('Adding...');

      dispatch(updateComments(props.opportunityId, data))
        .then(() => {
          if (data.type === 'comment') {
            //TODO: analysis pass proper key
            tagEvent(TAG_EVENT_CONST.comment, { AnomalyId: props.opportunityId });

            addComment(newNote);
            setacceptActionInProgress(false);
            setBtnText('Add Comment');
            setNewNote('');
            tagEvent(TAG_EVENT_CONST.comment, { AnomalyId: props.opportunityId });
          }
        })
        .catch(() => {
          setacceptActionInProgress(false);
          setEnableRetryErr(true);
          setBtnText('Retry');
          setNewNote(newNote);
        });

      setHasScript(false);
    } else {
      setHasScript(true);
    }
  };
  // download document API
  const handleDownload = async (
    insightId: number,
    storedFileName?: string,
    fileName?: string
  ) => {
    downloadFileStatusToast('loading');
    axios
      .get(
        `${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/download?file_name=${fileName}&stored_file_name=${storedFileName}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName ? decodeURIComponent(fileName) : insightId}`);
        document.body.appendChild(link);
        link.click();
        downloadFileStatusToast('success');
      })
      .catch((err) => {
        downloadFileStatusToast('failure');
        console.log(' error ', err);
      });
  };
  const handleCommentChange = (newNoteText: string) => {
    let inValidCharacter = /[<>()&#]/;
    if (inValidCharacter.test(newNoteText)) {
      setHasScript(true);
    }
    else {
      setNewNote(newNoteText)
      setHasScript(false);
    }
  }

  return (
    <div className="action-card-flex">
      <div className="action-card-flex-left">
        <div className="audit-comments-header">Activity</div>
     <>
          <Notes
            role_name={props.role_name}
            onClose={props.onClose}
            opportunityId={props.opportunityId}
            opportunityStatus={props.opportunityStatus}
            opportunityObjectName={props.opportunityObjectName}
            isAuditTrail={true}
          />
        </>
      </div>
      <div className="action-card-flex-right">
        <p className="comment-label">{addCommentText}</p>
        <NotesFooter
          onClose={props.onClose}
          opportunityId={props.opportunityId}
          opportunityObjectName={props.opportunityObjectName} />
      </div>
    </div>
  );
};
export default AuditTrailActivity;
